import {EmbedCodeExtractor} from "./types"

const PATTERNS = [
  /glomex-player([A-Za-z0-9\-=" ]+)>/i,
  /<glomex-integration([A-Za-z0-9\-=" ]+)>/i
]

const TARGET_INTEGRATION_REGEX = /(?:data-)?integration-id="([A-Za-z0-9-]+)"/i
const TARGET_PLAYLIST_REGEX = /(?:data-)?playlist-id="([A-Za-z0-9-]+)"/i

/**
 * Port of Tik::WebEmbedService::PreProcessor::Glomex (pre_processor/glomex.rb):
 * turns <glomex-player>/<glomex-integration> embed tags into the canonical
 * player/exchange URL.
 */
export const glomexPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      const htmlEscapedString = match[1]

      const matchIntegrationId = TARGET_INTEGRATION_REGEX.exec(htmlEscapedString)
      const matchDataPlaylistId = TARGET_PLAYLIST_REGEX.exec(htmlEscapedString)

      if(matchIntegrationId != null && matchDataPlaylistId != null) {
        if(/glomex-player/.test(input)) {
          return `https://player.glomex.com/integration/1/iframe-player.html?integrationId=${matchIntegrationId[1]}&playlistId=${matchDataPlaylistId[1]}`
        }
        return `https://exchange.glomex.com/playlist/${matchDataPlaylistId[1]}?integrationId=${matchIntegrationId[1]}`
      }
      // Ruby Base.call returns the (nil) process result of the first matching pattern
      // without trying the remaining patterns.
      return null
    }
  }
  return null
}
